<template>
  <div class="about-page">
    <section class="about-hero">
      <div v-if="about.image" class="about-hero__bg">
        <img class="about-hero__bg-img" :src="about.image" alt="" aria-hidden="true" />
        <div class="about-hero__overlay"></div>
      </div>
      <div class="section-container about-hero__content">
        <section v-reveal>
          <span class="section-label">About</span>
          <h1 class="section-title">{{ about.title }}</h1>
          <p v-if="about.subtitle" class="about-hero__subtitle">{{ about.subtitle }}</p>
        </section>
      </div>
    </section>

    <div class="about-body page-section">
      <div class="section-container">
        <section v-reveal>
          <p class="lead">{{ about.detail }}</p>
          <div v-if="about.richHtml" class="rich" v-html="about.richHtml" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["officialShell"],
  computed: {
    about() {
      const raw = (this.officialShell && this.officialShell.ctx && this.officialShell.ctx.aboutPage) || {};
      return {
        image: raw.image || "",
        title: raw.title || "关于我们",
        subtitle: raw.subtitle || "",
        detail:
          raw.detail ||
          "我们专注于跨境电商与跨境仓储行业的信息化建设，拥有多年行业经验与技术积累。公司以技术驱动为核心，通过自主研发的系统产品，持续为客户提供稳定、高效、可扩展的解决方案。",
        richHtml: raw.richHtml || ""
      };
    }
  }
};
</script>

<style scoped>
.about-hero {
  position: relative;
  min-height: 320px;
  display: flex;
  align-items: flex-end;
  padding: calc(var(--header-h) + 56px) 0 64px;
  overflow: hidden;
}

.about-hero__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.about-hero__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  transform: scale(1.02);
}

.about-hero__overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      105deg,
      rgba(255, 255, 255, 0.97) 0%,
      rgba(255, 255, 255, 0.88) 38%,
      rgba(246, 249, 255, 0.55) 68%,
      rgba(22, 119, 255, 0.12) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(248, 250, 252, 0.3) 0%,
      transparent 45%,
      rgba(10, 39, 93, 0.08) 100%
    );
}

.about-hero__content {
  position: relative;
  z-index: 1;
}

.about-hero__content .section-title {
  margin-bottom: 0;
}

.about-hero__subtitle {
  margin: 12px 0 0;
  max-width: 560px;
  font-size: 1rem;
  color: var(--text-muted);
  line-height: 1.75;
}

.about-body {
  padding-top: 64px;
}

.lead {
  margin: 0 0 18px;
  color: var(--text-muted);
  line-height: 1.9;
  font-size: 1rem;
}

.rich {
  color: var(--text-muted);
  line-height: 1.85;
  font-size: 0.95rem;
}

.rich ul,
.rich ol {
  margin: 0 0 12px;
  padding-left: 1.25em;
}

.rich li {
  margin-bottom: 8px;
}

.rich p {
  margin: 0 0 10px;
}

.rich h3 {
  margin: 18px 0 10px;
  font-size: 1.05rem;
  color: var(--primary-dark);
}

.rich h3:first-child {
  margin-top: 0;
}

.rich a {
  color: var(--primary);
}

@media (max-width: 767px) {
  .about-hero {
    min-height: 260px;
    padding-bottom: 48px;
  }
}
</style>
